import setupParallax from '@/utils/setupParallax';

export default function(dom, opts) {
	let options = {
		baseClass: 'scrollingmarquee',
		...opts
	};

	const text = dom.querySelector(`.${options.baseClass}__text`);
	const background = dom.querySelector(`.${options.baseClass}__background`);
	const contentWrapper = dom.querySelector(`.${options.baseClass}__content-wrapper`);
	let movementFactor = 3;

	const updateSizing = () => {
		dom.style.height = `${Math.max(text.clientWidth * 1.25, window.innerHeight * 1.75)}px`;
	};

	window.addEventListener('resize', updateSizing);
	updateSizing();

	const updateMarqueeParallax = ({factor, factorReversed}) => {
		text.style.transform = `translate3d(${factor * -(100 / text.clientWidth * (text.clientWidth - contentWrapper.clientWidth))}%, 0, 0)`;
		background.style.backgroundPosition = `-${factorReversed * (window.innerWidth * movementFactor)}px ${factorReversed * window.innerHeight}px`;
	};

	setupParallax(dom, updateMarqueeParallax, true);
}
